import request from '@/utils/request'

const TRANSACTION_LIST_PATH = '/merchants/orders/transaction/list'

/** Legacy GET transaction list (flat bracket query params). */
const fetchTransactionList = (data) => {
  return request({
    path: TRANSACTION_LIST_PATH,
    method: 'GET',
    data,
  })
}

/** New POST transaction list (nested filter payload). */
const fetchTransactionListPost = (data) => {
  return request({
    path: TRANSACTION_LIST_PATH,
    method: 'POST',
    data,
  })
}

export { fetchTransactionList, fetchTransactionListPost }
